import { atom } from 'jotai';

// Atom for phone number search
export const phoneNumberSearchAtom = atom<string>('');
export const filterPhoneNumberAtom = atom<string>('');

// Atom for project name search
export const projectNameSearchAtom = atom<string>('');
export const filterProjectNameAtom = atom<string>('');

// Atom for mobile filter popup visibility
export const showFilterPopupAtom = atom<boolean>(false);